import React from 'react';
import CreateOperationComponent from './CreateOperationComponent';
import { getOperationText, mapToFilter, mapFromFilter } from '../../common/Helpers';
import { apiFetch as fetch } from '../../common/Helpers';

class EditOperationPage extends React.Component {

    constructor(props) {
        super(props)

        const { params } = this.props.match;

        this.state = {
            id: params.id,
            operation: null
        };
    }

    render() {

        if (this.state.operation === null) {
            return null;
        }

        let productFilters = []
        let productFiltersLogicalOperator = "And";
        
        // TODO: Keep in mind that the api returns .filter object put we still work here with .productFilters
        if (this.state.operation.filter != null) {
            productFilters = this.state.operation.filter.children.map((_, index) =>  { return { ...(mapFromFilter(_)), id: index } });
            productFiltersLogicalOperator = this.state.operation.filter.logicalOperator;
        }

        let actions = this.state.operation.actions.map((_, index) =>  { return { ..._, id: index } });

        return (
            <CreateOperationComponent operation={
                {
                    actions: actions,
                    productFilters: productFilters,
                    productFiltersLogicalOperator: productFiltersLogicalOperator,
                    description: this.state.operation.description
                }}
                id={this.state.id}
                title="Edit Tag Operation"
                skipPreview={true}
                onCancel={this.handleCancel}
                onSubmit={this.handleSubmit} />
        );
    }

    handleSubmit = (operation) => {
        const mappedFilters = operation.productFilters.map(mapToFilter);
        const filter = {
            "filterType": "composite",
            "logicalOperator": operation.productFiltersLogicalOperator,
            "children": mappedFilters
        };
        let description = operation.description;
        if (description === "" || description === null) {
            description = getOperationText(operation);
        }
        fetch(`api/operations/tag/${this.state.id}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: this.state.id,
                description: description,
                actions: operation.actions,
                filter: filter
            })
        }).then(_ => {
            this.props.history.push(`/operations/${this.state.id}`);
        });
    }

    handleCancel = () => {
        this.props.history.push(`/operations/${this.state.id}`);
    }

    handleOnEdit = async () => {
    }

    componentDidMount() {
        fetch(`api/operations/tag/${this.state.id}`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => this.setState({
                operation: data,
            }));
    }
}

EditOperationPage.defaultProps = {

}

export default EditOperationPage;